import Box from '@mui/material/Box'
import IconButton from '@mui/material/IconButton'
import Stack from '@mui/material/Stack'
import Tooltip from '@mui/material/Tooltip'
import { GridToolbarFilterButton } from '@mui/x-data-grid'
import { Refresh } from 'mdi-material-ui'
import toast from 'react-hot-toast'
import { apiService } from '../../api/axiosClient'
import { useGetOrdersQuery } from '../../store/orderApi'

const CartToolbar = props => {
  const { numSelected, selected, setReload } = props
  const { refetch } = useGetOrdersQuery('주문');

  const UpdateCart = async () => {
    console.log('UpdateCart', selected)

    selected.forEach(async cart => {
        try {
            await apiService.put(`/carts/${cart.cartid}`, {
              "cartid": cart.cartid,
              "orderid": cart.orderid,
              "sku": cart.sku,
              "username": cart.username,
              "qty": cart.qty,
              "delivery_date": cart.delivery_date,
              "cprice": cart.cprice,
              "cdirect": cart.cdirect,
              "cselect": cart.cselect,
              "cstatus": cart.cstatus
            });
            toast.success('수정 되었습니다');
            // call rtk re-fetch()
            refetch();
            setReload(reload => reload + 1);
        } catch (error) {
            console.error(error);
        }
    });
  }

  return (
    <Box
      sx={{
        p: 2,
        pb: 0,
        display: 'flex',
        flexWrap: 'wrap',
        alignItems: 'flex-start',
        justifyContent: 'space-between'
      }}
    >
      <Box>
        <GridToolbarFilterButton />
      </Box>
      <Box sx={{ display: 'flex' }}>
        {numSelected > 0 ? (
          <Stack direction="row" spacing={2} sx={{ pr: 4 }}>
            <Tooltip title='Update'>
              <IconButton sx={{ color: '#006A4E' }} onClick={UpdateCart} >
                <Refresh />
              </IconButton>
            </Tooltip>
          </Stack>
        ) : null}
      </Box>

    </Box>
  )
}

export default CartToolbar
